interface IUserAgent {
    system: string;
    browser: string;
    version: number;
    versionOS?: string;
    userAgent: string;
}

const userAgent: string = navigator.userAgent;

export const getUserAgent = (): IUserAgent => {
    let system = "unknown";
    if (userAgent.match(/Windows/i)) {
        system = "Windows";
    } else if (userAgent.match(/Mac/i)) {
        system = "MacOS";
    } else if (userAgent.match(/Linux/i)) {
        system = "Linux";
    } else if (userAgent.match(/Android/i)) {
        system = "Android";
    } else if (userAgent.match(/iOS/i)) {
        system = "iOS";
    }

    let browser = "unknown";
    if (userAgent.match(/Firefox/i)) {
        browser = "Firefox";
    } else if (userAgent.match(/Chrome/i)) {
        browser = "Chrome";
    } else if (userAgent.match(/Safari/i)) {
        browser = "Safari";
    } else if (userAgent.match(/Edge/i)) {
        browser = "Edge";
    } else if (userAgent.match(/IE/i)) {
        browser = "Internet Explorer";
    }

    const versionMatch = userAgent.match(/(Version\/\d+\.\d+|Chrome\/\d+\.\d+|Firefox\/\d+\.\d+|Safari\/\d+\.\d+|Edge\/\d+\.\d+|MSIE \d+\.\d+)/);
    const version: number = versionMatch ? Number(versionMatch[0].split("/")[1]) : 0;

    const versionOSMatch = userAgent.match(/(Windows NT \d+\.\d+|Mac OS X \d+\_\d+|Android \d+\.\d+|CPU (iPhone )?OS \d+\_\d+)/);

    return {
        system,
        browser,
        version,
        userAgent,
    };
};

export const isIPhoneBrowser = (): boolean => {
    return /iPhone/i.test(userAgent);
};

export const isAndroidBrowser = (): boolean => {
    return /Android/i.test(navigator.userAgent);
};
export const isRunningFromHomeScreen = (): boolean => window.matchMedia("(display-mode: standalone)").matches;
